import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class PdfThumbnailService {
  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  async generateThumbnail(file: File | string, width = 150): Promise<string> {
    if (!isPlatformBrowser(this.platformId)) {
      // SSR: zwracamy placeholder lub null
      return '';
    }

    const pdfjsLib = await import('pdfjs-dist');

    // ustawienie workera
    pdfjsLib.GlobalWorkerOptions.workerSrc = `./assets/pdf.worker.min.mjs`;

    let loadingTask;
    if (file instanceof File) {
      const arrayBuffer = await file.arrayBuffer();
      loadingTask = pdfjsLib.getDocument({ data: arrayBuffer });
    } else {
      loadingTask = pdfjsLib.getDocument(file);
    }

    const pdf = await loadingTask.promise;
    const page = await pdf.getPage(1);

    const viewport = page.getViewport({ scale: 1 });
    const scale = width / viewport.width;
    const scaledViewport = page.getViewport({ scale });

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d')!;
    canvas.width = scaledViewport.width;
    canvas.height = scaledViewport.height;

    await page.render({
      canvasContext: context,
      viewport: scaledViewport
    }).promise;

    return canvas.toDataURL();
  }
}
